<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">Flugklasse</span>
        <div class="tmp-section-body tmp-flexy">
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="currentTravelClass === 'economy'"
                (click)="selectTravelClass('economy')" matRipple>Economy</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentTravelClass === 'premium'"
                (click)="selectTravelClass('premium')" matRipple>Premium Eco</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentTravelClass === 'business'"
                (click)="selectTravelClass('business')" matRipple>Business</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentTravelClass === 'first'"
                (click)="selectTravelClass('first')" matRipple>First</button>
        </div>
    </div>
</ng-container>